import { RequestDefinition } from 'front-end-core/core/Api'

import {
  toContent,
  toInstantSearch,
  toQuestions,
  toQAReferences,
  toSearch,
  toSections
} from './transforms'

import {
  URL_QA_CONTENT,
  URL_QA_INSTANTSEARCH,
  URL_QA_QUESTIONS,
  URL_QA_QUESTIONS_PREPAY,
  URL_QA_REFERENCES,
  URL_QA_SEARCH,
  URL_QA_SEARCH_PREPAY,
  URL_QA_SECTIONS,
  URL_QA_SECTIONS_PREPAY,
  URL_QA_CONTENT_PREPAY
} from 'constants/urls'

import {
  QA_CONTENT,
  QA_INSTANTSEARCH,
  QA_QUESTIONS,
  QA_QUESTIONS_PREPAY,
  QA_REFERENCES,
  QA_SEARCH,
  QA_SEARCH_PREPAY,
  QA_SECTIONS,
  QA_SECTIONS_PREPAY,
  QA_CONTENT_PREPAY
} from 'constants/requests'

export const QAContent = new RequestDefinition({
  name: QA_CONTENT,
  url: URL_QA_CONTENT,
  transform: toContent
})

export const QAContentPrepay = new RequestDefinition({
  name: QA_CONTENT_PREPAY,
  url: URL_QA_CONTENT_PREPAY,
  transform: toContent
})

export const QAInstantSearch = new RequestDefinition({
  name: QA_INSTANTSEARCH,
  url: URL_QA_INSTANTSEARCH,
  transform: toInstantSearch
})

export const QAQuestions = new RequestDefinition({
  name: QA_QUESTIONS,
  url: URL_QA_QUESTIONS,
  transform: toQuestions
})

export const QAQuestionsPrepay = new RequestDefinition({
  name: QA_QUESTIONS_PREPAY,
  url: URL_QA_QUESTIONS_PREPAY,
  transform: toQuestions
})

export const QAReferences = new RequestDefinition({
  name: QA_REFERENCES,
  url: URL_QA_REFERENCES,
  transform: toQAReferences
})

export const QASearch = new RequestDefinition({
  name: QA_SEARCH,
  url: URL_QA_SEARCH,
  transform: toSearch
})

export const QASearchPrepay = new RequestDefinition({
  name: QA_SEARCH_PREPAY,
  url: URL_QA_SEARCH_PREPAY,
  transform: toSearch
})

export const QASections = new RequestDefinition({
  name: QA_SECTIONS,
  url: URL_QA_SECTIONS,
  transform: toSections
})

export const QASectionsPrepay = new RequestDefinition({
  name: QA_SECTIONS_PREPAY,
  url: URL_QA_SECTIONS_PREPAY,
  transform: toSections
})
